export default __webpack_public_path__ + "static/media/MODE_diagram.d146caa2.svg";